import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  folder: {
    id: 'Folder',
    defaultMessage: 'Folder',
  },
  folderDescription: {
    id: 'Folder where to search',
    defaultMessage: 'Folder where to search',
  },
  linkTitle: {
    id: 'linkTitle',
    defaultMessage: 'linkTitle',
  },
  linkTo: {
    id: 'linkTo',
    defaultMessage: 'linkTo',
  },
});


export const schema = (props) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'folder', 'linkTitle', 'linkHref'],
      },
    ],
    properties: {
      title: {
        title: props.intl.formatMessage(messages.title),
        widget: 'text',
      },
      folder: {
        title: props.intl.formatMessage(messages.folder),
        description: props.intl.formatMessage(messages.folderDescription),
        widget: 'object_browser',
        mode: 'link',
      },
      linkTitle: {
        title: props.intl.formatMessage(messages.linkTitle),
      },
      linkHref: {
        title: props.intl.formatMessage(messages.linkTo),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title', 'Description'],
        allowExternals: true,
      },
    },
  };
};

export default schema;